// extracted by mini-css-extract-plugin
module.exports = {"atMention":"widget-space--atMention--3Yrms"};